import SavingsSlider from './SavingsSlider'

export default SavingsSlider
